// import * as Rules from './rules'
import * as siret from './siret'
import { isEmail } from 'validator'


/**
 * Validation function required
 * @param value value to test
 * @returns whether length > 0
 */
export const required = (value: string) => {
  if (!value) {
    return false
  }
  return value.length > 0
}

export const isEqual = (field: any) => {
  return (value: string, values: any) => {
    if (!values) {
      return true
    }
    return values[field] === value
  }
}

export const isNumber = (value: any) => {
  // for Select value
  if (typeof value === 'object') {
    return typeof value.value === 'number'
  }

  // for TextInput/Textarea value
  return typeof value === 'number'
}

export const min = (minNumber: number) => (value: number) => value >= minNumber
export const minLength = (minNumber: number) => (value: string): boolean => (String(value).length >= minNumber)
export const maxLength = (maxNumber: number) => (value: string): boolean => (String(value).length <= maxNumber)

export const siretOrSiren = (value: string) => {
  if (!value) {
    return true
  }
  return siret.isSIRET(value) || siret.isSIREN(value)
}

export const email = (value: string) => {
  if (!value) {
    return true
  }
  return isEmail(value)
}

export const password = (value: string) => {
  const re = /(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{6,}/
  return re.test(value)
}

export const deleteInput = (value: string) => {
  if (!value) {
    return true
  }
  return value === "SUPPRIMER"
}

/**
 * Validation function equal
 * @param equalTo value to compare with
 * @returns another function which takes the value to test and compares it with equalTo
 */
export const equal = (equalTo: string) => (value: string) => value === equalTo

/**
 *
 * @param validators list of validation functions with error messages alongside of
 * @param value accumulation of validation state and error message, calculated from right to left
 */
export const validate = (
  validators: Array<{ fn: (value: any, values?: any) => boolean; msg: string }>,
  value: any,
  values?: any,
) => {
  return validators.reduceRight(
    (acc, cur) => {
      const isValid: boolean = cur.fn(value, values)
      return {
        error: acc.error || !isValid,
        errorMessage: isValid ? acc.errorMessage : cur.msg,
      }
    },
    { error: false, errorMessage: '' },
  )
}

export const reduceErrors = (errors: { [key: string]: boolean }): boolean => {
  let result = false

  for (const key in errors) {
    if (errors.hasOwnProperty(key)) {
      result = result || errors[key]
    }
  }

  return result
}



// WEBPACK FOOTER //
// ./src/utils/validations/index.ts